<div class="trip-detail-popup-right">
  <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
</div>
<form class="admin-forms" [formGroup]="workorderForm">
  <div class="accordion-class">
    <h5>Create / Edit Work Order</h5>
    <mat-divider></mat-divider>
  </div>
  <div *ngIf="!enabledetails" class="input-fileds-container">
    <div class="group">
      <!-- SECTION: PROFILE -->
      <div class="first_row divider_mat">
        <div class="w-100">
          <h6 class="bill_details">Profile</h6>
          <mat-divider></mat-divider>
        </div>
      </div>
      <div class="first_row">
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Corporate Mobile No</mat-label>
            <mat-select placeholder="Select Corporate Mobile" dropLocationSearchField
              (selectionChange)="getCustomer($event)" required>
              <mat-option *ngFor="let corporate of activeCorporateList" [value]="corporate._id">
                {{ corporate.mobile }}
              </mat-option>
            </mat-select>
            <mat-error>Please Select Customer Mobile No</mat-error>
          </mat-form-field>
        </div>
        <div class="mtb w-100 d-flex align-items-center">
          <mat-label class="mr-2">Customer Name:</mat-label>
          <div class="details w-100">{{ customerName[0]?.username }}</div>
        </div>
      </div>

      <!-- SECTION: BILLING ADDRESS -->
      <div class="first_row divider_mat">
        <div class="w-100">
          <h6 class="bill_details">Billing Address</h6>
          <mat-divider></mat-divider>
        </div>
      </div>
      <div class="first_row">
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Full Name</mat-label>
            <input matInput formControlName="username" required />
            <mat-error>Please Enter Name </mat-error>
          </mat-form-field>
        </div>
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" type="email" />
            <mat-error>Please Enter Valid Email</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="first_row">
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Address Line 1</mat-label>
            <input matInput formControlName="address_line" required />
            <mat-error>Please Enter Address </mat-error>
          </mat-form-field>
        </div>
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>City</mat-label>
            <input matInput formControlName="city" required />
            <mat-error>Please Enter City </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="first_row">
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>State</mat-label>
            <input matInput formControlName="state" required />
            <mat-error>Please Enter State Name</mat-error>
          </mat-form-field>
        </div>
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Pincode</mat-label>
            <input matInput (keypress)="validateNumber($event)" formControlName="pincode" minlength="6" maxlength="6"
              required />
            <mat-error>Please Enter Pincode</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="first_row">
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>GST no. (optional)</mat-label>
            <input matInput uppercase appAlphanumericOnly formControlName="gst" minlength="15" maxlength="15" />
          </mat-form-field>
        </div>
        <div class="mtb w-100"></div>
      </div>

      <!-- SECTION: WORKORDER DETAILS -->
      <div class="first_row divider_mat">
        <div class="w-100">
          <h6 class="bill_details">Workorder Details</h6>
          <mat-divider></mat-divider>
        </div>
      </div>
      <div class="first_row">
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Pick Up Location</mat-label>
            <input class="input" style="color: black; float: right" formControlName="from_area_name"
              (change)="onInputPickUpchange()" #pickUpLocationSearchField matInput type="text" required />
            <span *ngIf="workorderForm.controls['from_area_name'].value" class="material-icons clear-icon" matSuffix
              (click)="clearPickUpField()">close</span>
            <mat-icon matPrefix class="mt-2">location_on</mat-icon>
            <mat-error>Please Enter Pickup Location</mat-error>
          </mat-form-field>
        </div>
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Drop Off Location</mat-label>
            <input (change)="onDropChange()" style="color: black; float: right" formControlName="to_area_name"
              #dropLocationSearchField matInput type="text" required />
            <span *ngIf="workorderForm.controls['to_area_name'].value" class="material-icons clear-icon" matSuffix
              (click)="clearDropUpField()">close</span>
            <mat-icon matPrefix class="mt-2">location_on</mat-icon>
            <mat-error>Please Enter Dropup Location</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="first_row">
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Pick Up Date</mat-label>
            <input matInput [matDatepicker]="picker" placeholder="Pickup Date" [min]="minDate"
              formControlName="pickup_date" (click)="picker.open()" required />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error>Please Enter Date</mat-error>
          </mat-form-field>
        </div>
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Truck category</mat-label>
            <mat-select dropLocationSearchField placeholder="Select Truck category" formControlName="truck_category"
              required>
              <mat-option *ngFor="let cat of truckCategory" value="{{ cat._id }}">{{ cat.truck_category_name }}
              </mat-option>
            </mat-select>
            <mat-error>Please select the truck category</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="first_row">
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>DO - Total Ton's</mat-label>
            <input matInput appThreeDigitDecimalNumber formControlName="total_tons" required />
            <mat-error>Please Enter Do Total Ton's</mat-error>
          </mat-form-field>
        </div>
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Price Per Ton</mat-label>
            <input matInput appTwoDigitDecimaNumber formControlName="price_per_ton" required />
            <mat-error>Please Enter Price Per Ton </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="first_row">
        <div class="mtb w-100 load_category">
          <p class="mr-2">Load Category:</p>
          <div class="load-details load-details-btn load-categorie" *ngFor="let item of loadCategory; let i = index">
            <div [class.load-categorie-selected]="i == loadCategorySelectedindex">
              <button type="button" id="getClick" (click)="loadCatChange(item.load_category, i)">
                {{ item.load_category }}
              </button>
            </div>
          </div>
        </div>
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Select Material Type</mat-label>
            <mat-select formControlName="material_type" required>
              <mat-option *ngFor="let item of materialDetails?.material_type" [value]="item.name">
                {{ item.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="
                loadCategorySelectedindex !== null && !materialTypeSelected
              ">Please select Material Type
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="first_row">
        <div class="mtb w-100 d-flex align-items-center">
          <mat-label class="mr-3">Payment Based on:</mat-label>
          <mat-form-field appearance="fill" class="w-100">
            <mat-select formControlName="pay_as_load_quantity" required
              (selectionChange)="selectLoadedQty($event.value)">
              <mat-option value="loaded_quantity">Loaded Qty</mat-option>
              <mat-option value="unloaded_quantity">Unloaded Qty</mat-option>
            </mat-select>
            <mat-error>Please select Payment based on</mat-error>
          </mat-form-field>
        </div>
        <div class="mtb w-100"></div>
      </div>

      <!-- SECTION: PICKUP AND DROPOFF CONTACT -->
      <div class="first_row divider_mat">
        <div class="w-100">
          <h6 class="bill_details">Pickup & Dropoff Contact</h6>
          <mat-divider></mat-divider>
        </div>
      </div>
      <div class="first_row">
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Pickup Contact Name</mat-label>
            <input matInput formControlName="pickup_name" required />
            <mat-error>Please Enter Pickup Contact Name</mat-error>
          </mat-form-field>
        </div>
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Pickup Contact Mobile</mat-label>
            <input matInput formControlName="pickup_contact" minlength="10" maxlength="10" required
              (keypress)="validateNumber($event)" />
            <mat-error>Please Enter Pickup Contact Mobile</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="first_row">
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Dropoff Contact Name</mat-label>
            <input matInput formControlName="dropoff_name" required />
            <mat-error>Please Enter Dropoff Contact Name</mat-error>
          </mat-form-field>
        </div>
        <div class="mtb w-100">
          <mat-form-field>
            <mat-label>Dropoff Contact Mobile</mat-label>
            <input matInput (keypress)="validateNumber($event)" formControlName="dropoff_contact" minlength="10"
              maxlength="10" required />
            <mat-error>Please Enter Dropoff Contact Mobile</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="ex0">
    <button type="button" class="button buttonBlue" [class.spinner]="loading" (click)="createWorkOrder($event)">
      Submit
    </button>
  </div>
</form>